import {Card} from 'platform/components';
import {Show, Text, VStack} from 'platform/foundation';

import {ReactNode} from 'react';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {TestIdProps} from 'shared/web';

interface PurchasePriceRuleFormSectionProps extends TestIdProps {
  title: string;
  description?: string;
  children: ReactNode;
}

export function PurchasePriceRuleFormSection(props: PurchasePriceRuleFormSectionProps) {
  return (
    <Card title={props.title} data-testid={props['data-testid']}>
      <VStack spacing={4}>
        <Show when={isNotNilOrEmpty(props.description) ? props.description : null}>
          {(description) => (
            <Text size="small" color="secondary">
              {description}
            </Text>
          )}
        </Show>
        {props.children}
      </VStack>
    </Card>
  );
}
